import { jsx as _jsx } from "react/jsx-runtime";
import { getInterFontWeightCSS } from '@prophecy/theme';
import styled from 'styled-components';
import { tokens } from './tokens';
export const AsteriskIcon = () => {
    return _jsx(StyledAsteriskIcon, { children: "*" });
};
const StyledAsteriskIcon = styled.span `
  color: ${tokens.Label.Asterisk.color};
  font-size: ${tokens.Label.Asterisk.fontSize};
  ${getInterFontWeightCSS(tokens.Label.Asterisk.fontWeight)};
  line-height: ${tokens.Label.Asterisk.lineHeight};
`;
